// extracted by mini-css-extract-plugin
export default {"coolClass":"Posts_coolClass__JV6C9","gridCustomWidth":"Posts_gridCustomWidth__Hp3kc","div":"Posts_div__v5Qkk"};